import { autoinject, useView } from 'aurelia-framework';
import { MdcDialog } from '@aurelia-mdc-web/dialog';
import { CustomerLookupViewModel } from '@dynamik/common/clients/policy-clients';

@autoinject
@useView('./add-company-dialog.html')
export class AddCompanyDialog {
  constructor(private dialog: MdcDialog) { }

  model: { customers: CustomerLookupViewModel[], selectedId: number };

  activate(model: { customers: CustomerLookupViewModel[], selectedId: number }) {
    this.model = model;
  }

  getOptions = (filter: string, value: number): Promise<CustomerLookupViewModel[]> => {
    if (value) {
        const selected = this.model.customers.find(x => x.id == value);
        return Promise.resolve(selected ? [selected] : []);
    }
    
    const lowerFilter = (filter || '').trim().toLowerCase();
    return Promise.resolve(this.model.customers
        .filter(x => (x.name || '').toLowerCase().includes(lowerFilter))
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        .slice(0, 50));
  }
}
